<template>
    <div class="home">
        <!-- 首页视频 -->
        <transition name="video-fade">
            <div v-if="showVideo && shouldPlayVideo" class="home-video-container" @click="hideVideo">
                <video v-if="homeparams.homeVideo" ref="homeVideo" :src="getUrl(homeparams.homeVideo)"
                    class="home-video" autoplay muted @ended="hideVideo" @click="hideVideo" playsinline
                    preload="metadata">
                </video>
            </div>
        </transition>

        <!-- 首页轮播 -->
        <el-carousel ref="carousel" height="100vh" direction="vertical" :autoplay="false" :loop="false"
            indicator-position="none" class="index-swiper">
            <!-- 第一屏 - 首页横幅 -->
            <el-carousel-item>
                <div class="index-banner">
                    <img v-if="homeparams.homeBg" class="banner-image" :src="getUrl(homeparams.homeBg)" alt="首页横幅图片">
                    <div class="text">
                        <div class="home-title wow animate__fadeInUp" v-html="homeparams.homeTitle"></div>
                        <div class="home-subtitle wow animate__fadeInUp" data-wow-delay="0.1s"
                            v-html="homeparams.homeSubtitle">
                        </div>
                        <div class="homedesc wow animate__fadeInUp" data-wow-delay="0.2s" v-html="homeparams.homeDesc">
                        </div>
                    </div>
                </div>
            </el-carousel-item>

            <!-- 第二屏 - 产品展示 -->
            <el-carousel-item>
                <div class="index-about">
                    <div class="index-banner about-image-banner">
                        <img v-if="homeparams.aboutBg" class="banner-image" :src="getUrl(homeparams.aboutBg)"
                            alt="关于我们横幅图片">
                        <div class="about-content">
                            <div class="about-title" v-html="homeparams.aboutTitle"></div>
                            <div class="about-desc" v-html="homeparams.aboutDesc"></div>
                            <router-link v-if="homeparams.aboutLink" :to="homeparams.aboutLink"
                                class="router-linkstyle product-link">
                                <span class="router-text">{{ homeparams.aboutBtnText }}</span>
                                <i class="el-icon-arrow-right"></i>
                            </router-link>
                        </div>


                    </div>
                </div>
            </el-carousel-item>

            <el-carousel-item v-for="item in getProjectImgList()" :key="item.id" :id="item.id">
                <div class="index-about">
                    <div class="index-banner project-image-banner" :style="getProjectImageStyle(item.img)">
                    </div>
                </div>
            </el-carousel-item>


            <el-carousel-item id="solution" class="solution-about" v-if="project">
                <div class="index-about ">
                    <div class="index-solution">
                        <div class="solution-content">
                            <div class="solution-title">
                                我们的解决方案</div>
                            <el-row :gutter="deviceGutter">
                                <el-col :span="solutionSpan" v-for="item in homeparams.solutions" :key="item.name">
                                    <div class="solution-item">
                                        <div class="solution-item-content">
                                            <div>{{ item.name }}</div>
                                            <router-link :to="item.link" class="router-linkstyle solution-link">
                                                <span>{{ item.linktext }}</span>
                                                <i class="el-icon-arrow-right"></i>
                                            </router-link>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item v-if="project">
                <div class="join-footer-content">
                    <div class="mission-statement">
                        <div class="mission-text"><span style="margin-right: 1.5vw;">技术扎根工业</span><span
                                style="margin-left: 1.5vw;">AI创造价值</span></div>
                    </div>
                </div>
                <div class="join-footer">
                    <SiteFooter />
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import SiteFooter from '@/components/Footer.vue'
import { imageServer } from '@/config'
import homemanagerapi from '@/api/HomeManager'
import commonapi from '@/api/common'

export default {
    name: 'HomePage',
    components: {
        SiteFooter
    },
    data() {
        return {
            project: false,
            imghttp: imageServer,
            homeparams: {},
            imageUrlCache: {}, // 图片URL缓存
            touchStartY: 0, // 触摸开始位置
            cooldownMs: 600, // 滚动/滑动全局冷却时间
            lastActionTime: 0, // 上次触发切换的时间
            currentSection: 0, // 当前所在的部分（0: 主轮播, 1: 产品轮播）
            showVideo: false, // 移动端不显示视频
            shouldPlayVideo: window.innerWidth > 768 // 移动端不播放视频
        }
    },
    computed: {
        // 根据解决方案数量和移动端状态计算span值
        solutionSpan() {
            // 使用768px断点判断移动端，与CSS媒体查询保持一致
            if (window.innerWidth <= 768) {
                return 24; // 移动端都为24
            }

            const count = this.homeparams.solutions ? this.homeparams.solutions.length : 0;

            switch (count) {
                case 1:
                    return 24;
                case 2:
                    return 12;
                case 3:
                    return 8;
                default:
                    return 12; // 默认值
            }
        },
        // 根据屏幕尺寸和项目数量计算解决方案列表的间距
        deviceGutter() {
            if (window.innerWidth <= 768) {
                return 20; // 移动端较小间距
            }

            const count = this.homeparams.solutions ? this.homeparams.solutions.length : 0;

            switch (count) {
                case 1:
                    return 0; // 单个项目不需要间距
                case 2:
                    return 180; // 两个项目使用较大间距
                case 3:
                    return 80; // 三个项目使用中等间距
                default:
                    return 80; // 默认间距
            }
        },
        // 计算解决方案轮播项的索引
        solutionCarouselIndex() {
            // 基础轮播项：首页横幅(0) + 产品展示(1) + 项目图片列表长度 + 解决方案
            // 解决方案的索引 = 2 + projectimglist.length
            const projectImgCount = this.getProjectImgList().length;
            return 2 + projectImgCount;
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$wow) {
                this.$wow.init();
            }
        });
        // 添加鼠标滚轮监听，设置 passive 为 false
        window.addEventListener('wheel', this.handleMouseWheel, { passive: false });
        // 添加触摸事件监听
        window.addEventListener('touchstart', this.handleTouchStart, { passive: false });
        window.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        // 添加事件总线监听，用于接收来自 App.vue 的菜单点击事件
        this.$bus.$on('scrollToHomeSection', this.scrollToSection);
        // 添加事件总线监听，用于接收停止视频播放的指令
        this.$bus.$on('stopVideo', this.hideVideo);
        // 添加事件总线监听，用于接收是否播放视频的指令
        this.$bus.$on('setVideoPlayState', this.setVideoPlayState);

        // 添加测试方法到全局，方便调试
        window.testHomeCache = {
            clear: () => {
                localStorage.removeItem('homeData');
                console.log('缓存已清除');
            },
            check: () => {
                const cached = localStorage.getItem('homeData');
                console.log('当前缓存:', cached);
                return cached;
            },
            reload: () => {
                this.getHomeData();
            }
        };
    },
    beforeDestroy() {
        // 移除鼠标滚轮监听，防止内存泄漏
        window.removeEventListener('wheel', this.handleMouseWheel, { passive: false });
        // 移除触摸事件监听
        window.removeEventListener('touchstart', this.handleTouchStart, { passive: false });
        window.removeEventListener('touchmove', this.handleTouchMove, { passive: false });
        // 移除事件总线监听
        this.$bus.$off('scrollToHomeSection', this.scrollToSection);
        this.$bus.$off('stopVideo', this.hideVideo);
        this.$bus.$off('setVideoPlayState', this.setVideoPlayState);

        // 清理测试方法
        if (window.testHomeCache) {
            delete window.testHomeCache;
        }
    },
    methods: {
        // 检测是否是移动端设备
        isMobile() {
            // 通过屏幕宽度判断（768px及以下视为移动端）
            return window.innerWidth <= 768;
        },
        // 获取项目图片列表（根据设备类型返回不同的列表）
        getProjectImgList() {
            if (this.isMobile() && this.homeparams.projectimglistmobile) {
                return this.homeparams.projectimglistmobile;
            }
            return this.homeparams.projectimglist || [];
        },
        handleMouseWheel(event) {
            const now = Date.now();
            if (now - this.lastActionTime < this.cooldownMs) {
                event.preventDefault();
                return;
            }
            const currentIndex = this.$refs.carousel.activeIndex;
            const totalItems = this.$refs.carousel.items.length;

            if (event.deltaY > 0) {
                if (currentIndex < totalItems - 1) {
                    this.$refs.carousel.next();
                    this.lastActionTime = now;
                }
            } else {
                if (currentIndex > 0) {
                    this.$refs.carousel.prev();
                    this.lastActionTime = now;
                }
            }

            event.preventDefault();
        },
        // 通过事件总线接收指令滚动到指定屏
        scrollToSection(index) {
            // 确保索引有效且当前不是正在滚动
            if (index >= 0 && index < this.$refs.carousel.items.length && !this.isScrolling) {
                this.$refs.carousel.setActiveItem(index);
            }
        },
        // 设置视频播放状态
        setVideoPlayState(shouldPlay) {
            this.shouldPlayVideo = shouldPlay;
            // 移动端始终不显示视频
            if (this.isMobile() || !shouldPlay) {
                this.showVideo = false;
            } else {
                this.showVideo = true;
            }
        },
        // 获取解决方案轮播项的索引
        getSolutionCarouselIndex() {
            return this.solutionCarouselIndex;
        },
        // 处理触摸开始事件
        handleTouchStart(event) {
            this.touchStartY = event.touches[0].clientY;
        },

        // 处理触摸移动事件
        handleTouchMove(event) {
            const now = Date.now();
            if (now - this.lastActionTime < this.cooldownMs) {
                return;
            }
            const touchEndY = event.touches[0].clientY;
            const touchDiff = this.touchStartY - touchEndY;
            const currentIndex = this.$refs.carousel.activeIndex;
            const totalItems = this.$refs.carousel.items.length;

            if (touchDiff > 0 && currentIndex < totalItems - 1) {
                this.$refs.carousel.next();
                this.lastActionTime = now;
            } else if (touchDiff < 0 && currentIndex > 0) {
                this.$refs.carousel.prev();
                this.lastActionTime = now;
            }
        },
        // 解析从后端收到的非标准JSON字符串
        parseNonStandardJsonString(jsonString) {
            if (typeof jsonString !== 'string') {
                return jsonString;
            }
            try {
                // 将JS对象写法的字符串修正为标准JSON格式
                // 1. 将键名用双引号包裹： e.g. {key: -> {"key":
                let correctedString = jsonString.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":');
                // 2. 将值中的单引号替换为双引号： e.g. '/path' -> "/path"
                correctedString = correctedString.replace(/'/g, '"');
                return JSON.parse(correctedString);
            } catch (e) {
                console.error('无法解析后端返回的字符串:', jsonString, e);
                return []; // 返回空数组以防页面崩溃
            }
        },
        // 批量检测图片加载完成
        waitAllImagesLoaded(urls) {
            return new Promise(resolve => {
                if (!urls.length) return resolve();
                let loaded = 0;
                urls.forEach(url => {
                    const img = new window.Image();
                    img.onload = img.onerror = () => {
                        loaded++;
                        if (loaded === urls.length) resolve();
                    };
                    img.src = url;
                });
            });
        },
        getHomeData() {
            // 先检查是否有缓存数据
            const cachedData = this.getCachedHomeData();
            if (cachedData) {
                // 如果有缓存数据，直接使用
                this.homeparams = cachedData;

                // 缓存数据加载完成后，允许渲染后续轮播项
                this.project = true;

                // 如果是PC端且有视频数据，显示视频
                if (!this.isMobile() && this.shouldPlayVideo && this.homeparams.homeVideo) {
                    this.showVideo = true;
                }
                return;
            }
            // 请求数据
            homemanagerapi.getHomeData().then(res => {
                let params = res.data.params;
                if (params.products) params.products = this.parseNonStandardJsonString(params.products);
                if (params.solutions) params.solutions = this.parseNonStandardJsonString(params.solutions);
                if (params.projectimglist) params.projectimglist = this.parseNonStandardJsonString(params.projectimglist);
                if (params.projectimglistmobile) params.projectimglistmobile = this.parseNonStandardJsonString(params.projectimglistmobile);
                this.homeparams = { ...this.homeparams, ...params };
                this.cacheHomeData(params);

                // 数据加载完成后，允许渲染后续轮播项
                this.project = true;

                // 如果是PC端且有视频数据，显示视频
                if (!this.isMobile() && this.shouldPlayVideo && this.homeparams.homeVideo) {
                    this.showVideo = true;
                }

                // 收集所有图片url
                let urls = [];
                if (params.products) {
                    urls = urls.concat(params.products.map(item => this.getUrl(item.backgroundImage)).filter(Boolean));
                }
                // 可继续添加其它图片字段
                return this.waitAllImagesLoaded(urls);
            }).catch(err => {
                console.error('获取首页数据失败:', err);
                this.homeparams = {
                    homeTitle: '欢迎访问',
                    homeSubtitle: '公司官网',
                    homeDesc: '加载失败，请刷新页面重试',
                    products: []
                };
            });
        },
        // 获取缓存的首页数据
        getCachedHomeData() {
            try {
                const cached = localStorage.getItem('homeData');
                if (!cached) {
                    // console.log('📭 localStorage中没有缓存数据');
                    return null;
                }

                const { data, timestamp } = JSON.parse(cached);
                const now = Date.now();
                const cacheExpiry = 1 * 60 * 60 * 1000; // 1小时缓存过期时间
                const timeDiff = now - timestamp;

                // console.log(`⏰ 缓存时间差: ${Math.round(timeDiff / 1000)}秒`);

                // 检查缓存是否过期
                if (timeDiff > cacheExpiry) {
                    // console.log('⏰ 缓存已过期，删除缓存');
                    localStorage.removeItem('homeData');
                    return null;
                }

                // console.log('✅ 找到有效缓存数据');
                return data;
            } catch (error) {
                console.error('❌ 读取缓存数据失败:', error);
                localStorage.removeItem('homeData');
                return null;
            }
        },

        // 缓存首页数据
        cacheHomeData(data) {
            try {
                const cacheData = {
                    data: data,
                    timestamp: Date.now()
                };
                localStorage.setItem('homeData', JSON.stringify(cacheData));
            } catch (error) {
                console.error('缓存数据失败:', error);
            }
        },
        // 隐藏视频
        hideVideo() {
            this.showVideo = false;
            // 视频在渐隐过程中继续播放，不停止
        },
        getUrl(imagePath) {
            if (!imagePath) return '';

            // 如果已经有缓存的URL，直接返回
            if (this.imageUrlCache && this.imageUrlCache[imagePath]) {
                return this.imageUrlCache[imagePath];
            }

            // 初始化缓存对象
            if (!this.imageUrlCache) {
                this.imageUrlCache = {};
            }

            // 发起请求获取URL
            commonapi.getImageUrl(imagePath).then(res => {
                const url = res.data.url;
                // 使用Vue.set确保响应式更新
                this.$set(this.imageUrlCache, imagePath, url);
            }).catch(error => {
                console.error('获取图片URL失败:', error);
                // 缓存空字符串，避免重复请求
                this.$set(this.imageUrlCache, imagePath, '');
            });

            // 返回空字符串，等待异步请求完成后通过响应式更新
            return '';
        },
        // 获取项目图片的样式
        getProjectImageStyle(imagePath) {
            if (!imagePath) {
                return { background: 'none' };
            }

            const url = this.getUrl(imagePath);
            if (!url) {
                return { background: 'none' };
            }

            // 在移动端使用 contain 确保图片完整显示，桌面端使用 cover
            if (this.isMobile()) {
                return {
                    background: `url(${url}) no-repeat center/contain`
                };
            } else {
                return {
                    background: `url(${url}) no-repeat center/cover`
                };
            }
        }
    },
    created() {
        this.getHomeData();
    }
}
</script>



<style scoped>
/* ===== 基础样式 ===== */
.home {
    min-height: 100vh;
    background-color: #00041f;
    overflow: hidden;
}

/* ===== 首页视频样式 ===== */
.home-video-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10000;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.home-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

/* 视频渐隐动画 */
.video-fade-enter-active,
.video-fade-leave-active {
    transition: opacity 1s ease-in-out;
}

.video-fade-enter,
.video-fade-leave-to {
    opacity: 0;
}

.video-fade-enter-to,
.video-fade-leave {
    opacity: 1;
}

/* ===== 轮播组件样式 ===== */
.index-swiper {
    height: 100vh;
}

.index-swiper .el-carousel__container {
    height: 100vh;
}

.index-swiper .el-carousel__item {
    height: 100vh;
    overflow: hidden;
}

/* 调整轮播动画时长（默认 800ms，可按需修改） */
.index-swiper /deep/ .el-carousel__item,
.index-swiper /deep/ .el-carousel__item.is-animating {
    transition: transform 900ms ease !important;
}

/* ===== 首页横幅 ===== */
.index-banner {
    height: 100vh;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.home-title {
    font-size: 1.4vw;
}

.home-subtitle {
    font-size: 3vw;
}

.homedesc {
    font-size: 1.2vw;
}

.homelink {
    font-size: 1vw;
}


.banner-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}

.index-banner .text {
    line-height: 10px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 10%;
    right: 10%;
    transform: translateY(-50%);
}

/* ===== 产品部分 ===== */
.index-about {
    height: 100vh;
    position: relative;
}

.index-solution {
    height: 100vh;
    width: 100%;
    position: relative;
}

.join-footer-content {
    height: 55vh;
    width: 100%;
    background-image: url('@/assets/images/sybj.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
}

.join-footer-content::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    z-index: 1;
}

.join-footer-content .mission-statement {
    height: 90%;
    position: relative;
    z-index: 2;
}

.join-footer {
    height: 45vh;
    width: 100%;
}

.about-content {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 10%;
    right: 10%;
    transform: translateY(-50%);
}

.about-title {
    font-size: 3vw;
    line-height: 0.8;
}


.about-desc {
    margin-top: 2%;
    line-height: 0.8;
    font-size: 1.2vw;
}


.product-link {
    color: #fff !important;
}

.product-link:hover {
    opacity: 0.8;
}

/* ===== 通用组件样式 ===== */
.router-linkstyle {
    display: inline-block;
    line-height: 1.6;
    text-decoration: none;
    color: inherit;
    font-size: 1.2vw;
}

.router-linkstyle i {
    margin-left: 5px;
    transition: transform 0.3s ease;
}

.router-linkstyle:hover i {
    transform: translateX(5px);
}

.more-3 {
    margin-top: 3vw;
}

.more-3 a {
    display: inline-flex;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 0.9vw;
    transition: all 0.3s ease;
}

.more-3 a:hover {
    opacity: 0.8;
}

.more-3 a i {
    margin-left: 0.5vw;
    transition: transform 0.3s ease;
}

.more-3 a:hover i {
    transform: translateX(5px);
}

.solution-content {
    width: 70%;
    margin: 10vh auto;
    position: relative;
    z-index: 2;
}

.solution-about {
    height: 100vh;
    background-image: url('@/assets/images/sybj.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
}

.solution-about::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 4, 31, 0.6);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 1;
}

.solution-title {
    color: white;
    font-size: 1.8vw;
    text-align: center;
    margin-bottom: 2vh;
}

.solution-item {
    height: 65vh;
    margin-top: 5vh;
    border-radius: 10px;
    text-align: center;
    font-size: 1.8vw;
    position: relative;
    color: white;
    background: radial-gradient(ellipse at center, #213357 10%, #67879f 100%);
}

.solution-item-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 5%;
}

.solution-link {
    margin-top: 50%;
}



/* ===== 使命宣言样式 ===== */
.mission-statement {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
}

.mission-text {
    font-size: 2.8vw;
    color: white;
    text-align: center;
    font-weight: 500;
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
    animation: missionGlow 3s ease-in-out infinite alternate;
}

@keyframes missionGlow {
    0% {
        text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
    }

    100% {
        text-shadow: 0 0 30px rgba(255, 255, 255, 0.6);
    }
}

/* ===== 响应式设计 ===== */
@media screen and (max-width: 768px) {

    /* 移动端图片样式 - 图片在中间，上下显示背景色 */
    .index-banner {
        background-color: #00041f;
    }

    .index-banner .text {
        top: 40%;
    }

    .home-title {
        font-size: 2.5vw;
    }

    .home-subtitle {
        font-size: 5vw;
    }

    .homedesc {
        font-size: 2.5vw;
    }

    .homelink {
        font-size: 1vw;
    }

    .about-title {
        font-size: 5vw;
    }

    .about-desc {
        font-size: 2.5vw;
    }

    .product-link {
        font-size: 2vw;
    }

    .banner-image {
        object-fit: cover !important;
        height: 50vh !important;
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .about-content {
        top: 40%;
    }

    .about-image-banner {
        background-color: #00041f !important;
    }

    .project-image-banner {
        background-color: #00041f !important;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 60vh;
        /* 确保移动端有足够的高度显示图片 */
    }

    .router-text {
        font-size: 2.5vw;
    }

    .index-banner .text {
        left: 5%;
    }

    .more-3 a {
        font-size: 14px;
    }

    .join-top {
        height: 50vh;
        /* background-color: #fff; */
        /* color: black; */
        position: relative;
        padding: 80px 0 0 5vw;
        font-size: 5vw;
    }

    .solution-content {
        width: 70vw;
        margin: 25vh auto;
    }

    .solution-title {
        font-size: 5vw;
        margin-bottom: 3vh;
    }

    .solution-item {
        height: 20vh;
        margin-top: 20px;
        text-align: center;
        font-size: 3vw;
    }

    .solution-item-content {
        margin-top: 5vh;
    }

    .router-linkstyle {
        display: inline-block;
        font-size: 2.5vw;
    }

    .solution-link {
        margin-top: 15px;
    }

    .mission-text {
        font-size: 5vw;
        margin-top: 20vh;
    }

    .join-footer {
        background: #0f0f0f;
    }
}
</style>